import { useIsMetabolicUser } from "@/features/metabolic-health/hooks/useMetabolicHealth";
import { useCallback, useEffect, useState } from "react";
import { getMedicalUserByRole } from "../../../utils/apis/medicaluser-service";
import { useAuthStore } from "../../../utils/stores/useAuthStore";
import { useExpertsStore } from "../../../utils/stores/useExpertsStore";
import { CalendlyExpert } from "../types/CalendlyExpert";
import { ExpertRole } from "../types/ExpertRole";

export const useExpertsByRole = (role: ExpertRole) => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId

    const { experts, updateExperts } = useExpertsStore()
    const storedExpert = experts[role]

    const [expert, setExpert] = useState<CalendlyExpert | null | undefined>(storedExpert)

    const isMetabolicUser = useIsMetabolicUser()

    const fetchExpert = useCallback(async () => {
        if (!idToken || !userId) return

        try {
            const experts = await getMedicalUserByRole(idToken, role)
            let specificExpert: CalendlyExpert | undefined

            if (experts && experts.length > 0) {
                if (role === ExpertRole.Specialist) {
                    specificExpert = experts.find((e) => e.email === "elvira.pistolesi@holifya.com")
                } else if (role === ExpertRole.Admin) {
                    specificExpert = experts.find((e) =>
                        ["admin@holifya.com", "tommaso.marchi@holifya.com"].includes(e.email)
                    )
                }
            }

            updateExperts({ [role]: specificExpert || null })
            setExpert(specificExpert)
        } catch (error) {
            console.error(`Error fetching ${role}:`, error)
            updateExperts({ [role]: null })
            setExpert(undefined)
        }
    }, [idToken, userId, role, updateExperts, isMetabolicUser])

    useEffect(() => {
        if (!storedExpert && idToken && userId) {
            console.log(`Fetching user with role=${role}`)
            fetchExpert()
        } else {
            console.log(`[${role.toUpperCase()}]: already stored, skipping the call`)
            setExpert(storedExpert)
        }
    }, [storedExpert, idToken, userId, fetchExpert])

    return { expert, fetchExpert }
}